<template>
  <div class="property-banner">
    <img :src="mobileresidentBanner" alt="" />
    <div class="absolute">
      <div class="title">业主APP、小程序</div>
      <div class="text">
        一机在手，满足业主各项需求，一键轻松解决问题，实现智能化社区生活服务平台，提升业主幸福感。
      </div>
       <div class="experience" @click="experienceClick">立即体验</div>
    </div>
  </div>
  <Experience
    v-if="experienceShow"
    :experienceShow="experienceShow"
    @experienceClick="experienceClick"
  ></Experience>
</template>

<script>
import { reactive } from "vue";

import Experience from "../../../../components/mobile/components/Experience.vue";

import mobileresidentBanner from "../../../../assets/product/mobileresidentBanner.png";

export default {
  setup() {
    return reactive({
      mobileresidentBanner: mobileresidentBanner,
      experienceShow: false,
    });
  },
  components: {
    Experience,
  },
  methods: {
    experienceClick() {
      this.experienceShow = !this.experienceShow;
    },
  },
};
</script>

<style scoped>
.property-banner {
  position: relative;
}
.property-banner img {
  width: 100%;
  height: 160px;
}
.absolute {
  width: 92vw;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
  text-align: center;
}
.absolute .title {
  font-size: 20px;
  color: #fff;
}
.absolute .text {
  font-size: 10px;
  margin-top: 12px;
  color: #fff;
}
.absolute .experience {
  margin: 0 auto;
  margin-top: 20px;
  color: #fff;
  border: 1px solid rgba(255,255,255,.8);
  border-radius: 6px 6px 6px 6px;
  text-align: center;
  cursor: pointer;
  width: 72px;
  height: 24px;
  line-height: 24px;
  font-size: 14px;
  border-radius: 20px 20px 20px 20px;
}
</style>
